import React from 'react'
import styled, { css } from 'styled-components'
import ButtonAlarm from 'components/Button/ButtonAlarm'
import ScheduleBottomOverlay from 'components/Schedule/ScheduleBottomOverlay'
import { dateParser, layoutSmall } from 'core/util/default'

const ScheduleList: React.FC<TypeScheduleItem> = (props) => {
  const {
    className,
    thumbnail,
    title,
    broadcastId,
    shopLogo,
    shopName,
    startTime,
    useAlarm,
    etcLinkUrl,
    etcLinkOpenType,
    LinkButtonTagAttributes,
    isShowPurchaseAuthBadge,
    isMobile,
    onClickAlarm,
    isConfirmAlarm,
  } = props
  const src = shopLogo + '?h=56&w=56&f=jpg'

  const handleClickAlarm = () => {
    if (!etcLinkUrl) {
      onClickAlarm && onClickAlarm(broadcastId)
      return
    }

    if (etcLinkOpenType === 'move') {
      return (window.location.href = etcLinkUrl)
    }
    if (etcLinkOpenType === 'open') {
      return window.open(etcLinkUrl, '_blank')
    }
    return
  }

  return (
    <StyledScheduleList className={className}>
      <button {...LinkButtonTagAttributes} className="schedule_wrapper">
        <ScheduleBottomOverlay isShowPurchaseAuthBadge={isShowPurchaseAuthBadge} />
        <img src={thumbnail} alt={title} />
      </button>
      <div className="info" tabIndex={0}>
        <div className="info_time">{startTime && dateParser(startTime)}</div>
        <div className="info_title">
          <span>{title}</span>

          {useAlarm && (
            <ButtonAlarm
              onClick={handleClickAlarm}
              buttonType={isMobile ? 'list' : 'feed'}
              isAlarm={isConfirmAlarm}
            />
          )}
        </div>
        <div className="thumbnail_wrapper">
          <div className="thumbnail" style={{ backgroundImage: `url(${src})` }} />
          <span className="info-partner">{shopName}</span>
        </div>
      </div>
    </StyledScheduleList>
  )
}

const StyledScheduleList = styled.div`
  display: flex;

  .schedule_wrapper {
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    margin-right: 10px;
    width: 180px;
    height: 135px;
    padding: 0;
    border: none;
    background-color: transparent;
    img {
      border-radius: 4px;
      overflow: hidden;
      width: inherit;
      height: inherit;
      border: solid 1px ${({ theme }) => theme.thumbnailLineColor};
    }
  }

  .info {
    width: 300px;
  }
  .info_time {
    overflow: hidden;
    white-space: nowrap;
    color: ${(props) => props.theme.scheduleTime};
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    margin-top: 5px;
    margin-bottom: 4px;
  }
  .info_title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > span {
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis;
      font-size: 14px;
      max-height: 40px;
      margin-right: 10px;
      line-height: 20px;
      /* white-space: nowrap; */
      font-weight: 600;
      color: ${(props) => props.theme.font.primary};
    }
  }

  .thumbnail_wrapper {
    margin-top: 4px;
    display: flex;
    align-items: center;

    .thumbnail {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      border: solid 1px ${({ theme }) => theme.thumbnailLineColor};
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      margin-right: 8px;
    }

    .info-partner {
      font-size: 12px;
      font-weight: 500;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 18px;
      color: ${(props) => props.theme.shopNameFont};
    }

    ${(props) =>
      !props.theme.shopName &&
      css`
        display: none;
      `}
  }
  ${layoutSmall(css`
    padding-left: 16px;
    .schedule_wrapper {
      width: 140px;
      height: 106px;
    }
    .info {
      width: 168px;
    }
  `)}
`
export default ScheduleList
